// extracted by mini-css-extract-plugin
export default {"container":"TitleDesc_container__czZW3","title":"TitleDesc_title__nW++7","description":"TitleDesc_description__OlZCC","divider":"TitleDesc_divider__W8fyq"};